import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Avatar, Layout, Menu, Typography, Spin } from 'antd';
import FullScreenButton from 'src/components/common/FullScreenButton';
import { MenuUnfoldOutlined, MenuFoldOutlined, LogoutOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useApolloClient } from '@apollo/client';
import VimeoVideo from 'src/components/common/VimeoVideo';
import ReturnToManagerBar from 'src/components/common/ReturnToManagerBar';
import styled from 'styled-components';

import { isLogedIn, userInfoVar, userVar } from 'src/apollo/cache';
import { USER_ME } from 'src/operations/queries/getUser';
import { useQueryProxy } from 'src/operations/proxy/user';
import { getCurrentToken } from '../../utils';
import { storage } from 'src/utils/hooks';
import { useSelector } from 'react-redux';
import { classStoreData } from 'src/operations/store';
import { isAfterSchool } from 'src/utils';
import { useMobileOrientation } from 'src/utils/hooks';

const { Header: HeaderWrapper } = Layout;
const { SubMenu } = Menu;
const { Text } = Typography;

const HeaderAITalking = styled(HeaderWrapper)`
  display: flex;
  flex-direction: row;
  justify-content: 'space-between';
  height: 64px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: transparent;
  /* background-image: ${(props) => !props.isStatic && `url('/images/cloud.png')`};
  background-position: ${(props) => !props.isStatic && `center bottom`};
  background-repeat: ${(props) => !props.isStatic && 'no-repeat'}; */
`;

const ImgButton = styled.img`
  cursor: pointer;
  width: 43px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;

const TalkingTutorHeader = ({ collapsed, onCollapse, isStatic = false }) => {
  const { isPortrait } = useMobileOrientation();
  const companyName = useSelector(classStoreData);
  const history = useHistory();
  const location = useLocation();
  const token = getCurrentToken();
  const client = useApolloClient();
  const userType = useMemo(() => {
    if (userInfoVar()) {
      return userVar()[userInfoVar().type];
    }
    return '';
  }, []);
  const guideVideosForAfterSchool = useSelector((state) => state.jsonData.guideVideosForAfterSchool);
  const { data } = useQueryProxy(USER_ME, { variables: { token } });

  const onLogout = () => {
    if (window.confirm('로그아웃 하시겠습니까?')) {
      isLogedIn(false);
      userInfoVar(null);
      client.clearStore();
      client.cache.gc();
      storage.removeItem('culp_token');
      window.location.reload();
    } else {
      return;
    }
  };

  const returnId = useMemo(() => {
    return window.localStorage.getItem('culp_return_id');
  }, []);

  const rightContent = (
    <>
      <Menu
        key="user"
        mode="horizontal"
        style={{
          height: '100%',
          background: 'transparent',
          border: 0,
          flex: 8,
          display: 'flex',
          justifyContent: 'flex-end',
          overflow: 'hidden',
        }}
      >
        {/* another guide video btn  */}
        {isAfterSchool(companyName) && ['campus', 'manager'].includes(userType) && ['/dashboard', '/'].includes(location.pathname) && (
          <Menu.Item key="info" style={{ paddingTop: '10px' }}>
            <VimeoVideo
              width={35}
              marginTop={14}
              thumpImage="/images/guide.png"
              item={guideVideosForAfterSchool && guideVideosForAfterSchool[companyName]?.[14]?.videos}
            />{' '}
          </Menu.Item>
        )}
        <Menu.Item key="info" style={{ paddingTop: '10px' }}>
          <FullScreenButton
            element={
              <ImgButton
                className="header-btn"
                src={location.pathname == '/ai-talking-tutor/topiclist' ? '/images/fullscreen.png' : '/images/fullscreen_blue.png'}
                alt="back arrow in header"
              />
            }
            activeElement={
              <ImgButton
                className="header-btn"
                src={location.pathname == '/ai-talking-tutor/topiclist' ? '/images/fullscreenExit.png' : '/images/fullscreenExit_blue.png'}
                alt="back arrow in header"
              />
            }
          />
        </Menu.Item>
        {/*  */}
        <SubMenu
          key="SubMenu"
          title={
            <>
              <Avatar

              //src="//image.zuiidea.com/photo-1487412720507-e7ab37603c6f.jpeg?imageView2/1/w/200/h/200/format/webp/q/75|imageslim"
              />
              <span style={{ color: isPortrait ? '#222' : '#ffffff', marginLeft: 10 }}>
                <span className="username">
                  {data?.me?.name}{' '}
                  <Text strong style={{ color: isPortrait ? '#222' : '#ffffff' }}>
                    ({data?.me?.view_id})
                  </Text>
                </span>
                <span onClick={onLogout} style={{ color: isPortrait ? '#222' : '#ffffff', marginLeft: 20 }}>
                  로그아웃
                  <LogoutOutlined
                    style={{
                      marginLeft: 5,
                      verticalAlign: 'middle',
                      fontSize: 25,
                      color: '#ccc',
                    }}
                    key="logout"
                  />
                </span>
              </span>
            </>
          }
        >
          {/* <Menu.Item key="SignOut" onClick={onLogout}>
            <span>Sign out</span>
          </Menu.Item> */}
        </SubMenu>
        {window.Android ? (
          <Menu.Item key="close" onClick={() => window.Android.closeApp()}>
            <span style={{ color: '#999' }}>
              <CloseCircleOutlined
                style={{
                  marginLeft: 20,
                  verticalAlign: 'middle',
                  fontSize: 25,
                  color: '#ccc',
                }}
                key="close"
              />
            </span>
          </Menu.Item>
        ) : null}
      </Menu>
    </>
  );

  return (
    <>
      {returnId && <ReturnToManagerBar returnId={returnId} />}
      <HeaderAITalking
        isStatic={isStatic}
        style={{
          position: isStatic ? 'fixed' : 'relative',
          // justifyContent: 'start',
          // alignItems: 'center',
          // height: '75px',
          // padding: '25px 65px',
          backgroundColor: '#1F317D',
          color: '#DEEBF7',
          fontSize: '40px',
        }}
      >
        <div style={{ visibility: `${userInfoVar()?.level_test === 1 ? 'hidden' : 'visible'}`, flex: 1 }}>
          <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
            {collapsed ? (
              <MenuFoldOutlined
                style={{
                  fontSize: 35,
                }}
                className="trigger"
                onClick={onCollapse}
              />
            ) : (
              <MenuUnfoldOutlined
                style={{
                  fontSize: 35,
                }}
                className="trigger"
                onClick={onCollapse}
              />
            )}
            {!isStatic && !isPortrait && (
              <div
                onClick={() => {
                  companyName !== 'epublic' && history.push('/');
                }}
                style={{ cursor: companyName !== 'epublic' && 'pointer', padding: '0 20px', width:companyName === 'epublic' ? '440px' : '420px' }}
              >
                {' '}
                <div>AI SPEAKING COACH</div>
              </div>
            )}
          </div>
        </div>
        {!isStatic ? <>{rightContent}</> : null}
      </HeaderAITalking>
    </>
  );
};

export default TalkingTutorHeader;
